import { Certificate } from '@revenuemarket/bank';

import { API } from '~apis/axios/instance';

interface CompanyIdentifier {
  companyId: string;
}

interface CertificateIdentifier extends CompanyIdentifier {
  certificateId: number;
}

interface PostAddCertificateOrganizationsResponse {
  data: { certificates: Certificate[] };
}

export function postAddCertificatesOrganizations({ companyId }: CompanyIdentifier) {
  return API.post<PostAddCertificateOrganizationsResponse>(
    `/api/v3/companies/${companyId}/certificates/add-organizations`,
  );
}

export function postAddCertificateOrganizations({
  companyId,
  certificateId,
}: CertificateIdentifier) {
  return API.post<PostAddCertificateOrganizationsResponse>(
    `/api/v3/companies/${companyId}/certificates/${certificateId}/add-organizations`,
  );
}
